import { ClientModel } from "../clientModel";
import { UserDropdownModel } from "../userDropdownModel";
import { ProductModel } from '../product/productModel';
import { FileModel } from "../fileModel";
import { OfferStatusHistoryModel } from "./offerStatusHistoryModel";

export class OfferAdminModel {
  public id: number;
  public offerStatusId: number;
  public offerNumber: string;
  public offerDate: string;
  public offerPrice: number;
  public offerDiscount: number;
  public fixedDiscount: number;
  public offerNotes: string;
  public client: ClientModel;
  public trader: UserDropdownModel;
  public offerFiles: Array<FileModel>;
  public gasInstallProducts: Array<ProductModel>;
  public gasAdditionalProducts: Array<ProductModel>;
  public heathInstallProducts: Array<ProductModel>;
  public heathAdditionalProducts: Array<ProductModel>;
  public additionalProducts: Array<ProductModel>;
  public statusHistory: Array<OfferStatusHistoryModel>;
  public disclaimer: string;
  public adminNotes: string;
}